<template>
  <section class="syi-detail-container">
    <!-- Primera fila: solo el botón "Anterior" -->
    <v-row class="pa-4" align="center">
      <v-col cols="12" md="2">
        <v-btn
          icon
          text
          class="d-flex align-center"
          @click="$router.go(-1)"
          aria-label="Anterior"
        >
          <v-icon left>mdi-chevron-left</v-icon>
          <span class="ml-1">Anterior</span>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Segunda fila: texto y la imagen -->
    <v-row class="pa-4" align="center">
      <v-col cols="12" md="8">
        <div class="text-caption text--secondary">Paso 1 de 3</div>
        <div class="text-h6 font-weight-regular">
          Para publicar más rápido, busquemos tu producto en nuestro catálogo
        </div>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-end">
        <img
          src="https://http2.mlstatic.com/frontend-assets/sell-list-core-front-end/notebook-v2.svg"
          alt="Ilustración de catálogo"
          style="width: 64px"
          decoding="async"
        />
      </v-col>
    </v-row>

    <!-- Aquí iría el buscador y lista de productos (tu código) -->
    <producto-buscador
      placeholderProp="Buscar productos en la empresa"
      :usarProductoEmpresa="usarProductoEmpresa"
      @process-buscador-producto="goToBuscador"
      @process-buscador-producto-select="goToBuscador"
      :showSuggest="false"
    />

    <div class="text-h6" v-if="productos_catalogo.length > 0">
      Estos productos coinciden con tu búsqueda. ¿Alguno es el tuyo?
    </div>

    <v-row class="mt-4" v-if="productos_catalogo.length > 0">
      <v-col>
        <v-divider></v-divider>
        <v-list two-line>
          <v-list-item
            v-for="producto in productos_catalogo"
            :key="producto.id"
            class="mb-2"
            @click="seleccionarProductoCatalogo(producto)"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ producto.descripcion }}
                <v-chip
                  v-if="producto.ya_registrado"
                  label
                  small
                  color="green"
                  class="ml-2"
                  text-color="white"
                >
                  Ya añadido
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-chip label small class="mr-2">
                  Categoría:
                  <span class="font-weight-bold ml-1">{{
                    producto.categoria || "N/A"
                  }}</span>
                </v-chip>
                <v-chip label small>
                  Marca:
                  <span class="font-weight-bold ml-1">{{
                    producto.marca || "N/A"
                  }}</span>
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon>
                <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-row v-else class="mt-4">
      <v-col>
        <v-alert
          type="info"
          outlined
          border="left"
          color="blue darken-2"
          icon="mdi-information-outline"
        >
          No se encontraron productos en el catálogo con esa descripción.
          <div class="mt-3">
            ¿Deseás registrar un nuevo producto?
            <v-btn
              small
              color="primary"
              class="ml-2"
              @click="registrarNuevoProducto"
            >
              Registrar producto
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import ProductoBuscador from "@/components/producto/buscador/producto.buscador.vue";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "producto.buscador.automatico",
  components: { ProductoBuscador },
  props: {
    categorias: Array,
    usarProductoEmpresa: Boolean,
    placeholderProp: {
      type: String,
      default: "Buscar productos en la empresa",
    },
  },
  computed: {
    ...mapState("productos", ["productos_catalogo"]),
  },
  methods: {
    ...mapMutations("productos", [
      "SET_CANTIDAD_PRODUCTOS_CATALOGO",
      "SET_PAGE_PRODUCTOS_CATALOGO",
      "SET_PRODUCTOS_CATALOGO",
      "SET_LOADING_PRODUCTOS_CATALOGO",
    ]),
    ...mapActions("productos", ["get_productos_catalogo_for_params"]),
    seleccionarProductoCatalogo(producto) {
      if (producto.ya_registrado) {
        this.$router.push({
          name: "productoEmpresaDetalle",
          params: {
            uuid_empresa: this.$route.params.uuid_empresa,
            id_producto: producto.producto_empresa_id,
          },
        });
      } else {
        this.$emit("set:productoCatalogo", producto);
      }
    },
    goToBuscador(search) {
      if (!search) {
        this.$router.replace({ path: "productos" }).catch(() => {});
        return;
      }
      this.SET_PAGE_PRODUCTOS_CATALOGO(1);
      const isBarcode = /^\d{7,}$/.test(search);
      const param = isBarcode ? { barcode: search } : { q: search };
      this.add_query_url(param);
      this.fetchProductosCatalogo();
    },
    fetchProductosCatalogo() {
      this.SET_PAGE_PRODUCTOS_CATALOGO(1);
      this.get_productos_catalogo_for_params(this.get_params_query());
    },
    add_query_url(value) {
      const newQuery = { ...this.$route.query };
      for (const key in value) {
        newQuery[key] = value[key].replace(/\s+/g, "-");
      }
      this.$router.replace({ query: newQuery }).catch((e) => {});
    },
    get_params_query() {
      const params = [];
      if (this.$route.params.categoria) {
        params.push({ key: "categoria", value: this.$route.params.categoria });
      }
      for (const key in this.$route.query) {
        params.push({ key, value: this.$route.query[key] });
      }
      params.push({ key: "global", value: true });
      return params;
    },
    registrarNuevoProducto() {
      this.$emit("registrar-nuevo-producto");
    },
  },
};
</script>

<style scoped>
.page-header {
  padding: 24px 16px;
  border-bottom: 1px solid #eee;
}

.page-header__body {
  display: flex;
  align-items: center;
  gap: 16px;
}
.page-header__image {
  width: 64px;
}
ul {
  padding-left: 1.25rem;
  margin-top: 0.5rem;
}
ul li {
  margin-bottom: 0.5rem;
}
</style>
